import { FilterKey } from "./components/DateFilterLinks";

export const BASE_URL =
  import.meta.env.VITE_API_URL ??
  "https://api.my.softwareformovers.com/api";

export const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const BIG_ITEMS = [
  "Washer/Dryer",
  "Refrigerator",
  "Flat Screen TVs",
  "Patio Furniture",
  "Upright Piano",
  "Grand Piano",
  "Concert Piano",
  "Pool Table",
  "Gun Safe",
  "Grandfather Clock",
  "Garage Gym Equipment",
];

export const FLOOR_LEVELS = {
  0: "Ground Floor (no stairs)",
  1: "One flight of stairs",
  2: "Two flights of stairs",
  3: "Three flights of stairs",
  4: "Four+ flights of stairs",
  99: "Elevator",
};

export const MOVE_KINDS = {
  apartment: "Apartment",
  sfh: "House",
  commercial: "Office",
  storage: "Storage",
  single_item: "Single Item",
};

export const MOVE_KINDS_SHORT = {
  apartment: "Apt.",
  sfh: "House",
  commercial: "Office",
  storage: "Storage",
  single_item: "Item",
};

export const SERVICE_TYPES = {
  move: "Move",
  pack_and_move: "Pack and Move",
  labor: "Labor Only",
  residential: "Residential",
  commercial: "Commercial",
  storage: "Storage",
  junk: "Junk Removal",
  trash: "Trash Removal",
  piano: "Piano Move",
  delivery: "Delivery",
  items: "Few Items",
  custom: "Custom Service",
};

export const SERVICE_TYPE_DESCRIPTIONS = {
  move: "May include packing",
  labor: "No trucks",
  residential: "May include packing",
  commercial: "Office and other commercial moves",
  storage: "Moves out of storage units",
  // junk: "Removing junk from a property",
  // trash: "Removing trash from a site",
  // items: "Moving a single or few items",
  custom: "Something else",
};

export const MOVE_STATUSES = {
  initial: "New",
  contacting: "Contacting",
  quoted: "Estimated",
  booked: "Booked",
  in_progress: "In Progress",
  completed: "Completed",
  lost: "Lost",
  canceled: "Canceled",
  expired: "Expired",
};

export const TEMPLATE_EVENTS = {
  post_new_lead: "After New Lead",
  post_quoted: "After Quoted",
  pre_move_day: "Before Move Day",
  post_move: "After Move",
};

export const ACTIVITY_ACTIONS = {
  send_move_confirmation: "Confirmation sent",
};

export const TEMPLATE_CATEGORIES = {
  customer_notes: "Customer Notes",
};

export const ACTIVITY_ACTION_TYPES = {
  called_customer: "Called",
  estimate_sent_to_customer: "Estimate Sent",
  texted_customer: "Sent customer a text",
};

export const SALES_OUTCOMES = {
  no_answer: "No Answer",
  left_voicemail: "Left VM",
  spoke_to_customer: "Connected",
};

export const USER_ROLES = {
  owner: "Owner",
  sales: "Sales",
  dispatcher: "Dispatcher",
  crew: "Crew",
};

export const CREW_ROLES = {
  leader: "Leader",
  helper: "Helper",
};

export const PAYMENT_PURPOSE_TYPES = {
  deposit: "Deposit",
  final_payment: "Final",
  additional_payment: "Additional",
};

export const LOST_LEAD_REASONS = {
  booked_elsewhere: "Booked elsewhere",
  duplicate: "Duplicate",
  price_is_high: "Price is high",
  no_longer_needed: "No longer needed",
  spam_or_fake: "Spam or fake",
  unable_to_contact: "Unable to contact",
  test: "Test",
  out_of_area: "Out of area",
  service_not_offered: "Service not offered",
};

export const CANCEL_REASONS = {
  no_longer_moving: "No longer moving",
  move_postponed: "Move postponed with no new date",
  moving_on_own: "Moving on their own",
  got_help_from_friends: "Got help from friends or family",
  found_better_price: "Found a better price",
  issue_with_property: "Issue with property",
  health_related_issues: "Health-related issues",
  financial_issues: "Financial issues",
};

export const CHARGE_PURPOSES = {
  deposit: "Deposit",
  final_payment: "Final Payment",
  additional_payment: "Additional Payment",
};

export const CARD_BRANDS = {
  visa: "Visa",
  mastercard: "Mastercard",
  american_express: "AmEx",
  discover: "Discover",
  americanexpress: "AmEx",
};

export const PAYMENT_METHODS = {
  card: "Card",
  venmo: "Venmo",
  paypal: "PayPal",
  zelle: "Zelle",
  cash: "Cash",
  check: "Check",
  apple_pay: "Apple Pay",
  google_pay: "Google Pay",
  ach: "ACH",
};

export const FILTER_LABELS: Record<FilterKey, string> = {
  today: "Today",
  yesterday: "Yesterday",
  last7: "Last 7 Days",
  last30: "Last 30 Days",
  last90: "Last 90 Days",
  thisWeek: "This Week",
  lastWeek: "Last Week",
  thisMonth: "This Month",
  lastMonth: "Last Month",
  thisQuarter: "This Quarter",
  lastQuarter: "Last Quarter",
  thisYear: "This Year",
  lastYear: "Last Year",
  allTime: "All Time",
};

export const MOVE_COLORS = {
  move: "bg-sky-800",
  residential: "bg-sky-800",
  items: "bg-sky-800",
  commercial: "bg-green-800",
  labor: "bg-purple-800",
  storage: "bg-amber-800",
  junk: "bg-rose-800",
  trash: "bg-rose-800",
  delivery: "bg-yellow-500",
  default: "bg-stone-500",
  onsite: "bg-emerald-500",
};

export const MOVE_COLORS_LIGHT = {
  move: "bg-sky-50",
  residential: "bg-sky-50",
  items: "bg-sky-50",
  commercial: "bg-green-50",
  labor: "bg-purple-50",
  storage: "bg-amber-50",
  junk: "bg-rose-50",
  trash: "bg-rose-50",
  delivery: "bg-yellow-50",
  default: "bg-stone-50",
  onsite: "bg-emerald-50",
};

export const LEGEND_TYPES = [
  { key: "residential", label: "Residential" },
  { key: "commercial", label: "Commercial" },
  { key: "labor", label: "Labor" },
  { key: "storage", label: "Storage" },
  { key: "junk", label: "Removal" },
  { key: "delivery", label: "Delivery" },
  { key: "onsite", label: "Onsite" },
  { key: "default", label: "Everything Else" },
];
